export * from './lib';
export * from './application';

import { Countdown } from './application'


const countdownDataElement = document.querySelector('[data-js=countdown-data]');

if (countdownDataElement) {
    const countdownData = JSON.parse(countdownDataElement.innerHTML);
    Countdown.initialize(+countdownData.expiration_timestamp);
}